<template>
  <v-container grid-list-md class="pa-5">
    <m-breadcrum :items="bread"></m-breadcrum>
    <v-row v-if="kelas">
      <v-col cols="12" sm="12" md="12" lg="12">
        <m-card title="Pratinjau Kelas">
          <v-row wrap>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-2 text-center">
              <v-card text color="#fff" flat>
                <v-img max-width="250" :src="kelas.cover ? kelas.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'" alt="avatar" />
              </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <v-list>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Nama Kelas</v-list-item-subtitle>
                        <div class="primary--text font-weight-bold body-1">
                          {{ pVal(kelas, "nama") }}
                          <p v-if="this.current_user.is_super_admin" class="black--text">(Kode Jenis: {{ pVal(kelas, "jenis") }})</p>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption grey--text">Angkatan</v-list-item-subtitle>
                        <div class="primary--text font-weight-bold body-1">
                          {{ pVal(kelas.angkatan, "nama") }}
                          <p v-if="this.current_user.is_super_admin" class="black--text">(Kode Angkatan: {{ pVal(kelas, "angkatan_id") }})</p>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="current_user.is_super_admin && false">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Learndash ID</v-list-item-subtitle>
                        <div class="body-1">{{ pVal(kelas, "learndash_id") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="current_user.is_super_admin && false">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Kode Learndash (Singkat)</v-list-item-subtitle>
                        <div class="body-1">{{ pVal(kelas, "singkat") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Tanggal Mulai Kelas</v-list-item-subtitle>
                        <div class="body-1">{{ pVal(kelas, "tanggal_mulai") | toDT }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Tanggal Selesai Kelas</v-list-item-subtitle>
                        <div class="body-1">{{ pVal(kelas, "tanggal_selesai") | toDT }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="kelas.is_selfenrol">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption grey--text">Tanggal Mulai Pendaftaran</v-list-item-subtitle>
                        <div class="">{{ pVal(kelas, "tgl_mulai_daftar") | toDT }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="kelas.is_selfenrol">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption grey--text">Tanggal Selesai Pendaftaran</v-list-item-subtitle>
                        <div class="">{{ pVal(kelas, "tgl_selesai_daftar") | toDT }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="kelas.is_selfenrol">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Nomor Sertifikat</v-list-item-subtitle>
                        <div class="">{{ pVal(kelas, "sertifikat_nomor") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="kelas.is_selfenrol">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Tanggal Terbit Sertifikat</v-list-item-subtitle>
                        <div class="">{{ pVal(kelas, "tgl_sertifikat") | toDT }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="!kelas.is_selfenrol">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Jumlah Maksimal Peserta</v-list-item-subtitle>
                        <div class="font-weight-bold body-1 primary--text">{{ $consts.PESERTA_COACHING_CLINIC }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="!kelas.is_selfenrol && false">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Jumlah Maksimal Master Trainer</v-list-item-subtitle>
                        <div class="font-weight-bold body-1 primary--text">1</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-if="!kelas.is_selfenrol">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Link Grup WA</v-list-item-subtitle>
                        <a :href="pVal(kelas, 'url_kelas')" target="_blank">{{ pVal(kelas, "url_kelas") }}</a>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Nilai Minimum</v-list-item-subtitle>
                        <div class="font-weight-bold body-1 primary--text">{{ pVal(kelas, "passing_grade") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Status Penilaian</v-list-item-subtitle>
                        <div>
                          <span :class="kelas.is_publish_nilai ? ' body-1 success--text' : ' body-1 black--text'">{{
                            kelas.is_publish_nilai ? "Terpublikasi" : "Belum dipublikasi"
                          }}</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption black--text">Status</v-list-item-subtitle>
                        <div>
                          <span :class="$kelas.statusColor(kelas.status_id) + `--text body-1`">{{ pVal(kelas.status_kelas, "keterangan") }}</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" v-if="!kelas.is_selfenrol" class="mt-2">
                    <v-alert icon="mdi-file-check-outline" prominent text type="info">
                      <span>Status Ketuntasan menyesuaikan dengan <strong>batas nilai minimum</strong> dimasukkan di setiap kelas</span>
                      <m-button
                        v-if="isCan('kelas-nilai') && kelas.is_publish_nilai == false && kelas.status_id == 2"
                        dark
                        class="my-2 mx-1"
                        :text-button="isCan('publish-nilai') ? 'Koreksi Nilai' : 'Masukkan Nilai'"
                        icon="mdi-file-check-outline"
                        color="orange"
                        action="toNilai"
                        @toNilai="toNilai"
                      ></m-button>
                      <m-button
                        id="publikasiNilai"
                        v-if="isCan('publish-nilai') && !kelas.is_publish_nilai && kelas.status_id == 2"
                        dark
                        class="my-2 mx-1"
                        text-button="Publikasi Nilai"
                        icon="mdi-file-check-outline"
                        color="success"
                        action="toPublishNilai"
                        @toPublishNilai="toPublishNilai(kelas)"
                      ></m-button>
                    </v-alert>
                    <div class="text-left mx-4 mb-2 mt-0 py-0" v-if="!kelas.is_selfenrol"></div>
                  </v-col>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
        </m-card>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="12" v-if="isShow">
        <ListPeserta
          class="mt-3"
          ref="peserta"
          :is_nilai="kelas.status_kelas && kelas.status_kelas.id == 2 ? true : false"
          :is_daring="kelas.is_selfenrol ? true : false"
          :is_kelas_tutup="is_kelas_tutup"
          :enroll="current_user.is_super_admin"
        />
      </v-col>
    </v-row>
    <FormNilai ref="nilaiDlg" />
  </v-container>
</template>
<script>
import ListPeserta from "../components/ListPeserta.vue";
import FormNilai from "../components/FormNilai.vue";

//@group Global Feature
export default {
  name: "kelas-detail",
  components: {
    ListPeserta,
    FormNilai
  },
  data() {
    return {
      kelas: {},
      isShow: false
    };
  },
  activated() {
    this.loadEnroll();
  },
  methods: {
    //@vuese
    //tampilkan detail kelas
    loadEnroll() {
      return this.$store
        .dispatch("kelas/detail", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          kelas_id: this.$route.params.kelas_id
        })
        .then(res => {
          this.kelas = res;
          this.isShow = true;
        })
        .catch(e => e);
    },
    //@vuese
    //tampilkan form penilaian kelas
    toNilai() {
      this.$refs.nilaiDlg.open().then(() => {
        this.loadEnroll();
        this.$refs.peserta.load();
      });
    },
    //@vuese
    //publikasi nilai kelas
    //@args objek kelas
    toPublishNilai(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasi nilai kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("kelas/nilaiPublish", item))
        .then(res => {
          if (res.error) {
            this.$error("Publikasi nilai kelas " + item.nama + " gagal");
          } else {
            this.$info("Publikasi nilai kelas " + item.nama + " berhasil");
          }
        })
        .then(() => this.loadEnroll())
        .catch(e => e);
    },
    //@vuese
    //unduh data peserta kelas
    toUnduhPeserta() {
      this.loading = true;
      return this.$store
        .dispatch("kelas/unduhPeserta", { instansi_id: this.current_instansi.id, kelas_id: this.$route.params.kelas_id, token: null })
        .then(res => {
          if (res) {
            this.loading = false;
            this.$info("Proses Unduh Data Peserta berhasil.");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$error("Proses Unduh Data Peserta gagal.");
        });
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Kelola Kelas",
          to: { name: "kelas", params: { instansi_id: this.instansi_id } }
        },
        {
          icon: "mdi-edit",
          title: this.kelas ? this.kelas.nama : "-"
        }
      ];
    },
    //@vuese
    //pengecekan kelas terbuka atau tertutup
    is_kelas_tutup() {
      if (this.kelas) {
        return this.$tools.parseIsAfter(this.$tools.parse0(this.kelas.server_time), this.$tools.parse7(this.kelas.tanggal_selesai));
      }
    }
  }
};
</script>
